import { render } from "./QuanTriNhanSu.vue?vue&type=template&id=d97503e4&scoped=true"
import script from "./QuanTriNhanSu.vue?vue&type=script&lang=js"
export * from "./QuanTriNhanSu.vue?vue&type=script&lang=js"

import "./QuanTriNhanSu.vue?vue&type=style&index=0&id=d97503e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d97503e4"]])

export default __exports__